/**
 * SelectableChipContainer — public entry for the SelectableChip molecule
 * (SE-5527). The chip is stateless; feature Containers own the value-binding
 * (e.g. `onSelect(option.value)`), so this Container is a memoized
 * passthrough that pins the molecule's public prop surface (Container/View
 * per the CreateWatchlistModal convention).
 * @module components/molecules/SelectableChip/SelectableChipContainer
 */
import React, { memo } from "react";

import type { SelectableChipViewProps } from "./SelectableChipView";
import SelectableChipView from "./SelectableChipView";

/** Public props for the SelectableChip molecule. */
export type SelectableChipProps = SelectableChipViewProps;

/**
 * Renders the SelectableChip view.
 * @param props - Chip props (see {@link SelectableChipViewProps})
 * @returns The chip element.
 */
const SelectableChipContainer = (props: SelectableChipProps) => (
  <SelectableChipView {...props} />
);

SelectableChipContainer.displayName = "SelectableChipContainer";

export default memo(SelectableChipContainer);
